import React, { useState, useEffect } from 'react';
import { getIssuesByProjectID, moveIssuesToProject, deleteProject, getProject } from '../../Service';
import { toast } from 'react-toastify';

const ProjectDeleteModal = ({ project, onClose, onActionComplete }) => {
    const [openIssues, setOpenIssues] = useState([]);
    const [targetProject, setTargetProject] = useState('');
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetchOpenIssues();
        fetchAllProjects();
    }, []);

    const fetchOpenIssues = async () => {
        try {
            const response = await getIssuesByProjectID(`issues/projects?project_ids=${project.project_id}`);
            console.log("Open Issues Response:", response, response.issues);
            setOpenIssues(response.issues); // Expecting array of open issues
        } catch (err) {
            toast.error('Failed to check open issues');
        }
    };

    const fetchAllProjects = async () => {
        try {
            const response = await getProject("/projects");
            const otherProjects = response.filter(p => p.project_id !== project.project_id);
            setProjects(otherProjects);
        } catch (err) {
            toast.error('Failed to fetch project list');
        }
    };

    const handleMove = async () => {
        if (!targetProject) {
            toast.warning("Please select a project to move issues.");
            return;
        }
        try {
            await moveIssuesToProject(`/issues/move`, {
                from_project_id: project.project_id,
                to_project_id: targetProject,
            });
            toast.success("Issues moved successfully.");
            handleDelete(); // proceed to delete after move
        } catch (err) {
            toast.error("Failed to move issues.");
        }
    };

    const handleDelete = async () => {
        try {
            const res = await deleteProject(`/projects/${project.project_id}`);
            toast.success(res.message || "Project deleted successfully.");
            onActionComplete();
        } catch (err) {
            toast.error("Failed to delete project.");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="filter-modal">
                <div className="filter-header">
                    <h3>Delete Project: {project.project_name}</h3>
                    <button className="btn btn-secondary" onClick={onClose}>✖</button>
                </div>
                {openIssues.length > 0 ? (
                    <>
                        <div className="modal-content">
                            <p className='mb-2'>This project has <strong>{openIssues.length}</strong> open issue(s).</p>
                            <label>Select a project to move issues:</label>
                            <select className="form-control mt-2" value={targetProject} onChange={e => setTargetProject(e.target.value)}>
                                <option value="">-- Select Project --</option>
                                {projects.map(p => (
                                    <option key={p.project_id} value={p.project_id}>{p.project_name}</option>
                                ))}
                            </select>

                        </div>
                        <div className="filter-footer">
                            <button className="btn btn-outline" onClick={onClose}>Cancel</button>
                            <button className="btn btn-danger" onClick={handleMove}>Move Issues & Delete</button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="modal-content">
                            <p>Are you sure you want to delete this project? This action cannot be undone.</p>
                        </div>
                        <div className="filter-footer">
                            <button className="btn btn-outline" onClick={onClose}>Cancel</button>
                            <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjectDeleteModal;
